<template>
    <span v-if="false" class="flex text-900 font-medium mb-4 xl:mb-6 
        text-2xl xl:text-3xl lg:text-5xl md:text-4xl">
        {{ todo[lang_].title }}:
    </span>
    <div v-if="false" class="w-full max-w-30rem">
        <div class="w-full mb-5">
            <div class="flex mb-4 pl-5 relative align-items-center">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">1</span>
                </div>
                <span class="flex text-600 pl-4">{{ todo[lang_].do1 }}:</span>
            </div>

            <div 
                class="w-full flex flex-1 surface-50
                flex-column xl:flex-row lg:flex-row md:flex-row
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer relative">
                <div class="flex flex-row">
                    <div class="flex flex-column mr-3 w-3 mb-4">
                        <img src="/images/partner_banner1.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner1.png">{{ todo[lang_].download }}</a>
                    </div>
                    <div class="flex flex-column mr-3 w-3">
                        <img src="/images/partner_banner2.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner2.png">{{ todo[lang_].download }}</a>
                    </div>
                    <div class="flex flex-column mr-3 w-3">
                        <img src="/images/partner_banner3.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner3.png">{{ todo[lang_].download }}</a>
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="flex flex-column mr-3 w-3">
                        <img src="/images/partner_banner4.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner4.png">{{ todo[lang_].download }}</a>
                    </div>
                    <div class="flex flex-column mr-3 w-3">
                        <img src="/images/partner_banner5.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner5.png">{{ todo[lang_].download }}</a>
                    </div>
                    <div class="flex flex-column mr-3 w-3">
                        <img src="/images/partner_banner6.png" download class="flex w-full border-round-md">
                        <a class="flex text-sm text-500 mt-1" download href="/images/partner_banner6.png">{{ todo[lang_].download }}</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full mb-5">
            <div class="flex mb-4 pl-5 relative align-items-center">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">2</span>
                </div>
                <span class="flex text-600 pl-4">{{ todo[lang_].do2 }}:</span>
            </div>

            <div 
                class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer relative">
                
                <div @click="copy(todo[lang_].copy1)" class="relative mb-3"> 
                    <span class="flex text-700 text-xl font-medium pr-4">
                        {{ todo[lang_].copy1 }}
                    </span>
                    <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                </div>
                <div @click="copy(todo[lang_].copy2)" class="relative mb-3"> 
                    <span class="flex text-700 text-xl font-medium pr-4">
                        {{ todo[lang_].copy2 }}
                    </span>
                    <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                </div>
                <div @click="copy(todo[lang_].copy3)" class="relative"> 
                    <span class="flex text-700 text-xl font-medium pr-4">
                        {{ todo[lang_].copy3 }}
                    </span>
                    <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                </div>
            </div>
        </div>

        <div class="w-full mb-5">
            <div class="flex mb-4 pl-5 relative align-items-center">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">3</span>
                </div>
                <span class="flex text-600 pl-4">{{ todo[lang_].do3 }}:</span>
            </div>

            <div @click="copy(partner_link)"
                class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer relative">
                <span 
                    class="flex text-700 font-medium white-space-nowrap
                    text-sm xl:text-2xl lg:text-xl md:text-lg pr-4">
                    <span>{{ partner_link }}</span>
                </span>
                <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                todo: {
                    ru: {
                        title: 'Как пригласить пользователей',
                        do1: 'Скачайте шаблоны изображения для сторис',
                        do2: 'Скопируйте готовое описание сервиса PayWave',
                        do3: 'Укажите вашу персональную ссылку',
                        copy1: 'Наконец-то появился удобный сервис обмена – PayWave',
                        copy2: 'Ловите сервис быстрых береводов Россия - Бали – PayWave',
                        copy3: 'PayWave – cервис переводов без крипты рубли – рупии',
                        download: 'Скачать',
                    },
                    en: {
                        title: 'How to invite users',
                        do1: 'Download story image templates',
                        do2: 'Copy the finished description of the PayWave service',
                        do3: 'Specify your personal link',
                        copy1: 'Finally, a convenient exchange service has appeared - PayWave',
                        copy2: 'Catch the fast transfer service Russia - Bali - PayWave',
                        copy3: 'PayWave - transfer service without crypto rubles - rupees',
                        download: 'Download',
                    }
                },
            }
        },
        computed: {
            lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
            isTgApp: function () { return this.$store.getters.StateTgApp },
            isDarkTheme() { return this.$store.getters.StateDarkTheme },
        },
        mounted() {
            this.helper.SetTgAppHeadColor("gray", this.isDarkTheme)
        },
    }
</script>